import React from 'react';
import classNames from 'classnames';
import { prettyKey } from '../helpers/formatters';

const RadioField = ({
  input,
  input: { name },
  meta: { touched, error },
  type = 'text',
  label,
  required,
  radioValue,
  ...rest
}) => (
  <div
    className={classNames({
      'form-group': true,
      'form-group-radio': true,
      'has-error': touched && error,
    })}
  >
    <input
      {...input}
      onChange={(e) => input.onChange(radioValue)}
      checked={input.value === radioValue}
      type="radio"
      className="form-control"
      id={radioValue}
      {...rest}
    />
    <label htmlFor={radioValue} className="control-label">
      {label ? label : prettyKey(name)} {required ? '*' : ''}
    </label>
    {touched && error && <span className="help-block">{error}</span>}
  </div>
);

export default RadioField;
